import React from "react"
import * as s from "./Wild.module.scss"

function supplySizeConfigurationForGhost(imageUrl, size = 1) {
  if (!/ghost/.test(imageUrl)) {
    return imageUrl
  }

  const regEx = /(?<rootPart>.*)\/content\/images\/(?<imgPart>.*)/
  const components = regEx.exec(imageUrl)

  const imgSize = `w${300 * size}`
  return `${components.groups.rootPart}/content/images/size/${imgSize}/${components.groups.imgPart}`
}

export const WildImage = ({
  imgSrc,
  imgSlug,
  className,
  size,
}) => {
  return (
    <a
      href={`/blog/${imgSlug}`}
      className={`${
        size === "large" ? s.largeImg :
        size === "small" ? s.smallImg : ""
      } ${className}`}
    >
      <img
        className={s.image}
        src={supplySizeConfigurationForGhost(imgSrc, size === "large" ? 2 : 1)}
        loading="lazy"
        alt=""
      />
    </a>
  )
}
